import AllProgrammes from './AllProgrammes';
import MyTherapyPlan from './MyTherapyPlan';
import MyTherapyGoals from './MyTherapyGoals';
import Dashboard from './Dashboard';
import Signup from './Signup';
import MyTherapist from './MyTherapist';
import IndividProgramme from './IndividProgramme';
import DeleteAccount from './DeleteAccount';
import MyAccount from './MyAccount';
import Update from './Update';
import Feedback from './Feedback';

export default {
  Dashboard,
  Signup,
  AllProgrammes,
  MyTherapist,
  IndividProgramme,
  MyTherapyPlan,
  MyTherapyGoals,
  DeleteAccount,
  MyAccount,
  Update,
  Feedback,
};
